var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerZonas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5834_3608)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5834_3608",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H0V35H35V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5834_3608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#151B4E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.504 12.74C16.768 12.74 16.17 12.5407 15.71 12.142C15.25 11.728 15.02 11.13 15.02 10.348C15.02 9.566 15.25 8.97567 15.71 8.577C16.17 8.163 16.768 7.956 17.504 7.956C18.24 7.956 18.838 8.163 19.298 8.577C19.758 8.97567 19.988 9.566 19.988 10.348C19.988 11.13 19.758 11.728 19.298 12.142C18.838 12.5407 18.24 12.74 17.504 12.74ZM15.066 27V18.168C15.066 17.8613 15.0583 17.478 15.043 17.018C15.0276 16.558 14.997 16.1057 14.951 15.661C14.9203 15.2163 14.8666 14.856 14.79 14.58L14.882 14.396H19.942V27H15.066Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5834_3608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerZonas);
export default __webpack_public_path__ + "static/media/verZonas.0d9a544e573cc34c44b1764f17e08e28.svg";
export { ForwardRef as ReactComponent };